import { GAMeasurementID } from 'core/constants';

export const GA = {
  disable: () => ((window as any)[`ga-disable-${GAMeasurementID}`] = true),
  enable: () => delete (window as any)[`ga-disable-${GAMeasurementID}`],
};
